import React from 'react';
import opacityIcon from "./opacity_icon.svg";
import './style.scss'

const OpacityButton = ({onClick}) => {
  return (
    <button id="opacityButton" className="" onClick={()=>onClick()}>
      <img src={opacityIcon}></img>
    </button>
  )
}

export default OpacityButton;